import React from 'react'

const FlightDetailsRoute = () => {
    return (
        <svg width="19" height="83" viewBox="0 0 19 83" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2086_100720)">
                <rect x="10" width="34" height="1" transform="rotate(90 10 0)" fill="#B3B3B3" />
            </g>
            <path
                d="M11.4 49.1C11.4 50.1493 10.5493 51 9.5 51C8.45066 51 7.6 50.1493 7.6 49.1L7.6 45.775L0 40.55V38.65L7.6 40.55L7.6 35.8L5.7 33.9V32L9.5 33.9L13.3 32V33.9L11.4 35.8L11.4 40.55L19 38.65V40.55L11.4 45.775V49.1Z"
                fill="#B3B3B3"
            />
            <g clip-path="url(#clip1_2086_100720)">
                <rect x="10" y="49" width="34" height="1" transform="rotate(90 10 49)" fill="#B3B3B3" />
            </g>
            <defs>
                <clipPath id="clip0_2086_100720">
                    <rect x="10" width="34" height="1" rx="0.5" transform="rotate(90 10 0)" fill="white" />
                </clipPath>
                <clipPath id="clip1_2086_100720">
                    <rect x="10" y="49" width="34" height="1" rx="0.5" transform="rotate(90 10 49)" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default FlightDetailsRoute
